export const ALL_PROJECTS = 'All Projects';
export const FAVORITE_PROJECTS = 'Favorite Projects';
export const RECENT_PROJECTS = 'Recent Projects';
